/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-log-cinematic-section-dns';
const prefix = `${moduleName}.${componentName}`;

export const dnsRequestLabel = `${prefix}.dnsRequestLabel`;
export const dnsResponseLabel = `${prefix}.dnsResponseLabel`;

export const ENGLISH = {
    [dnsRequestLabel]: 'DNS Request',
    [dnsResponseLabel]: 'DNS Response',
};
